"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.Context = React.createContext({
    applePayState: 'loading',
    formId: '',
    googlePayState: 'loading',
    masterpassState: 'loading',
    onCreateNonce: function () { },
    onVerifyBuyer: function (source, verificationDetails, callback) { },
});
exports.default = exports.Context;
//# sourceMappingURL=Context.js.map